import { createStore } from 'vuex'

// const URL = 'http://localhost:5005/';
const URL = 'https://server-web.konaweselatankab.go.id/';
const URL_SIMPEG = 'https://server-egov.konaweselatankab.go.id/';
var UNIT = 'kxFjL7W84BoY5PM3P';

export default createStore({
  state: {
    UNIT_KERJA : UNIT,
    url: {
      URL_APP_SIMPEG: URL_SIMPEG, 
      URL_APP: URL,
      URL_BERITA: URL + 'api/v1/web_publish_berita/',
      URL_LINK_TERKAIT: URL + 'api/v1/web_publish_link_terkait/',

      URL_SLIDER: URL + 'api/v1/publish_pk_slider/',
      URL_SAMBUTAN: URL + 'api/v1/publish_pk_sambutan/',
      URL_FOTO: URL + 'api/v1/publish_pk_galeri_foto/',
      URL_VIDEO: URL + 'api/v1/publish_pk_galeri_video/',
      
      URL_DATA_PEGAWAI: URL + 'api/v1/publish_pk_data_pegawai/',
      URL_PROFIL_DINAS: URL + 'api/v1/publish_pk_gambaran_umum/',
      URL_TUJUAN: URL + 'api/v1/publish_pk_visimisi/',
      URL_STRATEGI: URL + 'api/v1/publish_pk_rencana_strategis/',
      URL_KEBIJAKAN: URL + 'api/v1/publish_pk_perjanjian_kinerja/',
      URL_PROGRAM: URL + 'api/v1/publish_pk_rencana_kerja/',
      URL_STRUKTUR_ORGANISASI: URL + 'api/v1/publish_pk_struktur_organisasi/',

      URL_REGULASI: URL + 'api/v1/publish_pk_peraturan/',
      URL_DATA_DOKUMEN: URL + 'api/v1/publish_pk_data/',
    },
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
